// @ts-nocheck
import _ from 'lodash';
import markdownIt from 'markdown-it';
import markdownItAnchor from 'markdown-it-anchor';
import markdownItInline from 'markdown-it-for-inline';
import { html5Media } from 'markdown-it-html5-media';
import hljs from 'highlight.js';
import mk from '@traptitech/markdown-it-katex';
import he from 'he';
import AmIt from './markdown-it-asciimath';
import { mhchemParser } from 'mhchemparser';

/* Escapes html tags */
const replaceTagsFromContent = (content: string) => {
  return content.replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

export const markdownHighlightFunction = (str, lang) => {
  const replacedTagsString = replaceTagsFromContent(str);
  if (lang && hljs.getLanguage(lang)) {
    try {
      return hljs.highlight(he.decode(replacedTagsString), { language: lang }).value;
    } catch (_e) {
      // ignore
    }
  }

  return replacedTagsString;
};

export const markdownItInlineFunction = (tokens, idx) => {
  const tIndex = tokens[idx].attrIndex('target');

  const href = tokens[idx].attrs[tokens[idx].attrIndex('href')];
  const isProbablyAnchorLink = href && href[1] && _.startsWith(href[1], '#');

  // Set 'target=_blank' on non-anchor links
  if (!isProbablyAnchorLink) {
    if (tIndex < 0) {
      tokens[idx].attrPush(['target', '_blank']);
    } else {
      tokens[idx].attrs[tIndex][1] = '_blank';
    }
  }
};

const md = markdownIt({
  breaks: true,
  typographer: true,
  linkify: true,
  html: true,
  highlight: markdownHighlightFunction,
});

md.use(markdownItAnchor, {});
md.use(mk, {
  blockClass: 'math-block',
  errorColor: '#cc0000',
  macros: {
    // Add mhchemparser support
    // Based on the katex mhchem function 'chemParse':
    // https://github.com/KaTeX/KaTeX/blob/main/contrib/mhchem/mhchem.js
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '\\ce': context => {
      const tokens = context.consumeArgs(1)[0];
      let str = '';
      let expectedLoc = tokens.length && tokens[tokens.length - 1].loc.start;
      for (let i = tokens.length - 1; i >= 0; i--) {
        if (tokens[i].loc.start > expectedLoc) {
          // context.consumeArgs has eaten a space.
          str += ' ';
          expectedLoc = tokens[i].loc.start;
        }
        str += tokens[i].text;
        expectedLoc += tokens[i].text.length;
      }
      const tex = mhchemParser.toTex(str, 'ce');
      return tex;
    },
  },
});
md.use(AmIt);
md.use(markdownItInline, 'url_new_win', 'link_open', markdownItInlineFunction);
md.use(html5Media);

export default md;
